/**
 * Distinct center labels from batches (VE Location of Center), not a fixed city list.
 */
export function locationsFromBatches(batches = [], extra = []) {
  const seen = new Set();
  const values = [];
  for (const item of [...(batches || []), ...(extra || [])]) {
    const raw =
      typeof item === 'string' || typeof item === 'number'
        ? item
        : item?.location;
    const text = String(raw || '').trim();
    if (!text) continue;
    const key = text.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    values.push(text);
  }
  return values.sort((a, b) => a.localeCompare(b));
}

export function locationOptionsFromBatches(batches = [], extra = []) {
  return locationsFromBatches(batches, extra).map((location) => ({
    value: location,
    label: location,
  }));
}

/**
 * Merge catalog names with leftover batch/form values so legacy labels still appear.
 */
export function mergeCenterOptions(...lists) {
  const seen = new Set();
  const options = [];
  for (const list of lists) {
    for (const item of list || []) {
      const raw =
        typeof item === 'string' || typeof item === 'number'
          ? item
          : item?.value ?? item?.name ?? item?.location;
      const text = String(raw || '').trim();
      const key = text.toLowerCase();
      if (!text || seen.has(key)) continue;
      seen.add(key);
      options.push({ value: text, label: text });
    }
  }
  return options.sort((a, b) => a.label.localeCompare(b.label));
}
